var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransmission(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3C7.02945 3 3 7.02945 3 12C3 16.9706 7.02945 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02945 16.9706 3 12 3ZM7.8 12.6V15.9C7.8 16.2314 7.53138 16.5 7.2 16.5C6.86862 16.5 6.6 16.2314 6.6 15.9V12C6.6 11.6686 6.86862 11.4 7.2 11.4H11.4V8.1C11.4 7.76862 11.6686 7.5 12 7.5C12.3314 7.5 12.6 7.76862 12.6 8.1V11.4H16.2V8.1C16.2 7.76862 16.4686 7.5 16.8 7.5C17.1314 7.5 17.4 7.76862 17.4 8.1V15.9C17.4 16.2314 17.1314 16.5 16.8 16.5C16.4686 16.5 16.2 16.2314 16.2 15.9V12.6H12.6V15.9C12.6 16.2314 12.3314 16.5 12 16.5C11.6686 16.5 11.4 16.2314 11.4 15.9V12.6H7.8Z",
    fill: "#717171"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransmission);
export default __webpack_public_path__ + "static/media/transmission.df42ec7d128a31272473742c0d88856a.svg";
export { ForwardRef as ReactComponent };